import styles from './../styles/style.module.scss';

export const SELECT_ARROW = `${styles.home_arrow}`;
export const countryList = ['Africa', 'Americas', 'Asia', 'Europe', 'Oceania'];
